import axios from "axios";

export default axios.create({
    // baseURL: "http://yazdgisheold.local/Api",
    baseURL: "https://yazdgishe.ir/Api",
    // baseURL: "https://sport.yazdgishe.ir/api",
    // baseURL: "http://yazdgishesport.local/api",
    // headers: {
    //     "Content-type": "application/json",
    // }
});